import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import { ApolloProvider, useLazyQuery } from 'react-apollo';
import isEqual from 'lodash.isequal';
import { useInView } from 'react-intersection-observer';
import WhiteMarker from './WhiteMarker';
import { nearbyRentalsQuery } from '../constants/queries';
import { client } from './client';
import RentalMarker from './Map/RentalMarker';

function ListingNearbyRentals({ center, type, icon }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [bounds, setBounds] = useState('');
  const [mapRendered, setMapRendered] = useState(false);

  const [
    fetchNearbyRentals,
    { data, error, loading, variables },
  ] = useLazyQuery(nearbyRentalsQuery);

  if (error) console.error(error);

  const [nearbyRentalsRef, inView] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      const queryVars = { polygon: bounds };
      const sameVars = isEqual(queryVars, variables);
      if (!sameVars && bounds)
        fetchNearbyRentals({ variables: { polygon: bounds } });
      setMapRendered(true);
    }
  }, [bounds, fetchNearbyRentals, inView, variables]);

  return (
    <section ref={nearbyRentalsRef} className="page-nearby-rentals">
      <h2 className="page-section-title">Nearby Rentals</h2>

      <div className="page-nearby-rentals-map">
        {loading && (
          <div className="loading-markers-overlay">
            <div className="loading-spinner" />
          </div>
        )}
        {mapRendered && (
          <GoogleMapReact
            bootstrapURLKeys={{
              // @TODO: Add this to an environment variable or something
              key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
            }}
            defaultCenter={center}
            defaultZoom={13}
            onChange={({ bounds: newBounds }) => {
              const { sw, ne } = newBounds;
              const swLat = sw.lat.toFixed(6);
              const swLng = sw.lng.toFixed(6);
              const neLat = ne.lat.toFixed(6);
              const neLng = ne.lng.toFixed(6);
              setBounds(`[${swLng},${swLat},${neLng},${neLat}]`);
            }}
          >
            <WhiteMarker
              lat={center.lat}
              lng={center.lng}
              type={type}
              icon={icon}
            />
            {data &&
              data.properties &&
              data.properties.collection.map(property => (
                <RentalMarker
                  key={property.id}
                  lat={property.latitude}
                  lng={property.longitude}
                  property={property}
                  activeMarker={activeMarker}
                  changeActiveMarker={setActiveMarker}
                />
              ))}
          </GoogleMapReact>
        )}
      </div>
    </section>
  );
}

export default function ListingNearbyRentalsWrapper(props) {
  return (
    <ApolloProvider client={client}>
      <ListingNearbyRentals {...props} />
    </ApolloProvider>
  );
}
